import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SharedService } from '../_shared/shared.service';


@Injectable({ providedIn: 'root' })
export class HttpPlus {

  constructor(private httpClient: HttpClient, protected shared: SharedService) {
    shared.checkForUpdates(httpClient)
  }

  async get(url: string, params: any = null, hideLoader: boolean = false, headers: any = {}) {
    await this.waitForToken()
    if (hideLoader)
      headers.params = { "hideLoader": true }
    if (params) {
      const httpParams = new HttpParams({ fromObject: params })
      url = `${url}?${httpParams.toString()}`
    }
    return this.httpClient.get(`${environment.apiUrl}${url}`, headers).toPromise().catch((e) => this.shared.logError(e));
  }

  async getAsset(url: string, hideLoader = false, headers: any = {}) {
    await this.waitForToken()
    if (hideLoader)
      headers.params = { "hideLoader": true }
    return this.httpClient.get(`assets/${url}`, headers).toPromise().catch((e) => this.shared.logError(e));
  }

  async post(url: string, params: any = {}) {
    await this.waitForToken()
    return this.httpClient.post(`${environment.apiUrl}${url}`, params).toPromise().catch((e) => this.shared.logError(e));
  }

  async put(url: string, params: any = {}) {
    await this.waitForToken()
    return this.httpClient.put(`${environment.apiUrl}${url}`, params).toPromise().catch((e) => this.shared.logError(e));
  }

  async delete(url: string, params: any = {}) {
    await this.waitForToken()
    if (params && Object.keys(params).length > 0)
      params = { params: params }
    return this.httpClient.delete(`${environment.apiUrl}${url}`, params).toPromise().catch((e) => this.shared.logError(e));
  }

  async waitForToken() {
    if (this.shared.refreshingToken) {
      console.log("REFRESH TOKEN - WAITING")
      return new Promise((resolve) => {
        let timeout = null

        const watcher = this.shared.refreshingTokenWatch
          .subscribe((value) => {
            if (!value) {
              console.log("REFRESH TOKEN FINISH")
              watcher.unsubscribe()
              resolve(true)
              if (timeout)
                clearTimeout(timeout)
            }
          })
          
        timeout = setTimeout(() => {
          console.log("REFRESH TOKEN FINISH TIMEOUT!!!")
          watcher.unsubscribe()
          resolve(true)
        }, 5000);
      });
    } else
      return true
  }
}


export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'
}